import { render } from "./Image.vue?vue&type=template&id=3d83f684"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d83f684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d83f684', __exports__)) {
    api.reload('3d83f684', __exports__)
  }
  
  module.hot.accept("./Image.vue?vue&type=template&id=3d83f684", () => {
    api.rerender('3d83f684', render)
  })

}


export default __exports__